module.exports = __webpack_public_path__ + "img/circulo.adc469ba.png";